import { useMutation } from '@tanstack/react-query'
import { sendTransactionsReport } from 'services/TransactionService'

export const useSendTransactionsReportMutation = () =>
  useMutation({ mutationFn: sendTransactionsReport })
